var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"template-field__checkbox"},[_c('NcCheckboxRadioSwitch',{attrs:{"id":_vm.fieldId,"checked":_vm.value,"type":"switch"},on:{"update:checked":[function($event){_vm.value=$event},_vm.input]}},[_vm._v("\n\t\t"+_vm._s(_vm.fieldLabel)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }